export async function downloadFile(url: string, filename: string) {
  try {
    const response = await fetch(url)
    const blob = await response.blob()
    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = downloadUrl
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(downloadUrl)
  } catch (error) {
    console.error('Error downloading file:', error)
  }
}

export async function downloadAllFiles(
  files: Array<{ _type: 'file'; asset: { url: string } }>,
) {
  if (!files || files.length === 0) return

  for (const file of files) {
    if (!file.asset?.url) continue

    // Extract filename from URL
    const filename = file.asset.url.split('/').pop() || 'download'
    await downloadFile(file.asset.url, filename)
  }
}
